import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from "./AbstractWelcomePage";
class RetryPopup extends AbstractWelcomePage {
    render() {
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-content" },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "testoPopup" },
                    React.createElement("br", null),
                    this.props.t('RetryPopup.abbandono')),
                React.createElement("h4", { className: "testoPopup" }, this.props.t('RetryPopup.riprova')))));
    }
}
export default translate(connect(_mapStateToProps)(RetryPopup));
